import React,{useContext} from 'react'
import { IcheerContext } from '../Context/AppContext';

const Logo = () => {
      const {  websiteDetails } = useContext(IcheerContext);
  return (
    <div>

        <a href={websiteDetails.url || 'https://312070-30.myshopify.com/'} target="_blank" rel="noopener noreferrer">
                  <img
                    src={websiteDetails.logo_url || 'https://cdn.shopify.com/s/files/1/0661/5177/6421/files/Logo_app.png'}
                    alt="iCheer Logo"
                    className="img-fluid"
                    
                  />
                </a>
      
    </div>
  )
}

export default Logo
